module.exports = __webpack_public_path__ + "img/diamond.f0ef2e8d.png";